export type BreedOutcome = "excluded" | "review";

export const breedSuggestions = [
  "Airedale Terrier","Akita","Alaska Malamute","American Akita",
  "American Bully","American Staffordshire Terrier","Australian Labradoodle",
  "Australian Shepherd","Basenji","Basset Hound","Beagle","Bearded Collie",
  "Beauceron","Berner Sennenhond","Bichon Frisé","Boerboel","Border Collie",
  "Boston Terrier","Bouvier des Flandres","Boxer","Briard","Bull Terrier",
  "Bullmastiff","Cairn Terrier","Cane Corso","Chihuahua","Chow Chow",
  "Cockapoo","Cocker Spaniël","Collie","Dalmatische Hond","Dobermann",
  "Dogo Argentino","Dogo Canario","Duitse Dog","Duitse Herdershond",
  "Dwergkees / Pomeranian","Engelse Bulldog","Engelse Cocker Spaniël",
  "Engelse Mastiff","Fila Brasileiro","Flatcoated Retriever","Foxterrier",
  "Franse Bulldog","Golden Retriever","Goldendoodle","Gordon Setter",
  "Grote Zwitserse Sennenhond","Havanezer","Hollandse Herdershond","Hovawart",
  "Ierse Setter","Jack Russell Terrier","Kangal","Kleinspitz","Komondor",
  "Kruising / mix","Kuvasz","Labradoodle","Labrador Retriever","Leonberger",
  "Maltezer","Mastiff","Mechelse Herder","Middelgrote Poedel","Mittelspitz",
  "Napolitaanse Mastiff","Nederlandse Schapendoes","Newfoundlander",
  "Old English Sheepdog","Parson Russell Terrier","Pekingees","Picardische Herder",
  "Pitbull-type","Podenco","Poedel","Portugese Waterhond","Presa Canario",
  "Rhodesian Ridgeback","Riesenschnauzer","Rottweiler","Saarlooswolfhond",
  "Samojeed","Schotse Collie","Shar-Pei","Shiba","Shih Tzu","Siberian Husky",
  "Sint Bernard","Staffordshire Bull Terrier","Teckel","Tibetaanse Mastiff",
  "Tosa Inu","Tsjechoslowaakse Wolfhond","Vizsla","Weimaraner",
  "Welsh Corgi","West Highland White Terrier","Witte Zwitserse Herder",
  "Yorkshire Terrier"
].sort((a,b) => a.localeCompare(b, "nl"));

const excludedTerms = [
  "duitse herdershond","hollandse herdershond","belgische herdershond",
  "mechelse herder","mechelaar","groenendaeler","tervueren","laekense herder",
  "beauceron","briard","picardische herder","witte zwitserse herder",
  "tsjechoslowaakse wolfhond","saarlooswolfhond",
  "dobermann","rottweiler","cane corso","dogo argentino","dogo canario",
  "presa canario","boerboel","tosa inu","fila brasileiro",
  "engelse mastiff","mastiff","bullmastiff","napolitaanse mastiff",
  "bordeauxdog","bordeaux dog","hovawart","riesenschnauzer",
  "american staffordshire terrier","staffordshire bull terrier",
  "pitbull","pit bull","american bully","bull terrier","miniature bull terrier",
  "kangal","anatolische herder","kaukasische herder","centraal-aziatische herder",
  "tibetaanse mastiff","komondor","kuvasz",
  "pomeranian","dwergkees","kleinspitz","mittelspitz","chihuahua"
];

const normalize = (value: string) =>
  value.toLowerCase().replace(/\s+/g, " ").trim();

export function classifyBreed(breed: string, mixDetails = ""): BreedOutcome {
  const haystack = normalize(`${breed} ${mixDetails}`);
  return excludedTerms.some((term) => haystack.includes(term))
    ? "excluded"
    : "review";
}
